import type { ApprovalChain } from '../approval-chain.model';

export const LAND_TENURE_NOTARIAL_DEED_SECTION_CHAIN: ApprovalChain = {
  id: 'land-tenure-notarial-deed-section',
  label: 'Land Tenure Notarial Deed Section',
  applicationTypes: ['LAND_TENURE_NOTARIAL_DEED_SECTION'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
